import { axiosInstanceMain } from "../../../utils/axiosGlobalUtils";
import { ITenant } from "../../AbmLocalPage/types";

interface ProductosSearchProps {
  idLocal?: string;
  idRubro?: string;
  nombreProducto?: string;
  soloActivos?: boolean;
  publicadoDesde: string | null;
  publicadoHasta: string | null;
}

export const getProductos = async (
  {
    idLocal = "",
    idRubro = "",
    nombreProducto = "",
    soloActivos = true,
    publicadoDesde = null,
    publicadoHasta = null,
  }: ProductosSearchProps,
  tenant: ITenant
) => {
  let url = `/admin/${tenant.path}/productos?`;

  if (idLocal !== "") url += `idLocal=${idLocal}&`;
  if (idRubro !== "") url += `idRubro=${idRubro}&`;
  if (nombreProducto !== "") url += `nombre-producto=${nombreProducto}&`;
  if (publicadoDesde) url += `fecha-publicacion-desde=${publicadoDesde}&`;
  if (publicadoHasta) url += `fecha-publicacion-hasta=${publicadoHasta}&`;

  url += `solo-activos=${soloActivos}`;

  return await axiosInstanceMain.get(url);
};

export const aprobar = async (idProducto: number, tenant: ITenant) =>
  await axiosInstanceMain.post(
    `/admin/${tenant.path}/productos/${idProducto}/aprobar`
  );
export const rechazar = async (idProducto: number, tenant: ITenant) =>
  await axiosInstanceMain.post(
    `/admin/${tenant.path}/productos/${idProducto}/rechazar`
  );
export const pausar = async (idProducto: number, tenant: ITenant) =>
  await axiosInstanceMain.post(
    `/admin/${tenant.path}/productos/${idProducto}/pausar`
  );
export const reanudar = async (idProducto: number, tenant: ITenant) =>
  await axiosInstanceMain.post(
    `/admin/${tenant.path}/productos/${idProducto}/despausar`
  );
export const borrar = async (idProducto: number, tenant: ITenant) =>
  await axiosInstanceMain.delete(
    `/admin/${tenant.path}/productos/${idProducto}`
  );
